import React from "react";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import PropTypes from "prop-types";

import RbCheckbox from "../RbCheckbox";

export const RbCheckboxControl = React.forwardRef(function RbCheckboxControl(
  props,
  ref
) {
  const {
    checkedIcon,
    color,
    disableRipple,
    icon,
    id,
    indeterminate,
    indeterminateIcon,
    inputProps,
    inputRef,
    required,
    size,
    value,
    onChangeChecked,
    ...other
  } = props;

  return (
    <FormControlLabel
      ref={ref}
      control={
        <RbCheckbox
          checkedIcon={checkedIcon}
          color={color}
          disableRipple={disableRipple}
          icon={icon}
          id={id}
          indeterminate={indeterminate}
          indeterminateIcon={indeterminateIcon}
          inputProps={inputProps}
          inputRef={inputRef}
          required={required}
          size={size}
          value={value}
          onChangeChecked={onChangeChecked}
        />
      }
      {...other}
    />
  );
});

RbCheckboxControl.propTypes = {
  checked: PropTypes.bool,
  checkedIcon: PropTypes.node,
  classes: PropTypes.object,
  color: PropTypes.oneOf(["default", "primary", "secondary"]),
  disabled: PropTypes.bool,
  disableRipple: PropTypes.bool,
  icon: PropTypes.node,
  id: PropTypes.string,
  indeterminate: PropTypes.bool,
  indeterminateIcon: PropTypes.node,
  inputProps: PropTypes.object,
  inputRef: PropTypes.object,
  label: PropTypes.string,
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  onChange: PropTypes.func,
  onChangeChecked: PropTypes.func,
  required: PropTypes.bool,
  size: PropTypes.oneOf(["medium", "small"]),
  value: PropTypes.bool,
};

RbCheckboxControl.defaultProps = {
  checked: undefined,
  checkedIcon: undefined,
  classes: undefined,
  color: undefined,
  disabled: undefined,
  disableRipple: undefined,
  icon: undefined,
  id: undefined,
  indeterminate: undefined,
  indeterminateIcon: undefined,
  inputProps: undefined,
  inputRef: undefined,
  label: undefined,
  labelPlacement: undefined,
  onChange: undefined,
  onChangeChecked: undefined,
  required: undefined,
  size: undefined,
  value: undefined,
};

export default React.memo(RbCheckboxControl);
